export default __webpack_public_path__ + "static/media/plusicon.ccb4d640.svg";